import { defineStore, type Pinia } from 'pinia';
import { type UserState } from './types';
import { ref } from 'vue';
import { getUser, isLogin } from '@/utils/auth';

export const ensureUserHydrated = (pinia: Pinia, cookie?: string) => {
  if (!isLogin(cookie)) {
    return;
  }

  const userStore = useUserStore(pinia);

  if (!userStore.user.id) {
    userStore.fetchInfo(cookie);
  }
};

const useUserStore = defineStore('user', () => {
  const getInitUser = (): UserState => ({
    id: undefined,
    photo: undefined,
    username: undefined,
    nickname: undefined,
    email: undefined,
    phone: undefined,
  });

  const user = ref<UserState>(getInitUser());

  const setInfo = (partial: Partial<UserState>) => {
    user.value = { ...user.value, ...partial };
  }

  const resetInfo = () => {
    user.value = getInitUser();
  }

  // Get user's information
  const fetchInfo = (cookie?: string) => {
    if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
      setInfo({
        id: '1',
        photo: 'https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png',
        email: 'wangliqun@email.com',
        username: 'wangliqun',
        nickname: 'wlq',
      });
    }
    else {
      setInfo(getUser(cookie));
    }
  }

  return { user, setInfo, resetInfo, fetchInfo };
});

export default useUserStore;
